import actionTypes from './../constants/actionTypes';

const initialState = {
    cronJobListing: {},
    tradeAlertList: {},
    actionsResponse: [],
    saveResponse: {},
    accessControlList: {},
    historyDateSummary: {},
};

export const adminReducer = (state = initialState, action) => {
    try {
        const { type, payload, status } = action;
        switch (type) {
            case actionTypes.ADMIN.CRONJOB_LIST: {
                return {
                    ...state,
                    cronJobListing: payload
                }
            }
            case actionTypes.ADMIN.TRADE_ALERT_LIST: {
                return {
                    ...state,
                    tradeAlertList: payload
                }
            }
            case actionTypes.ADMIN.ACTIONS_COMPLETE: {
                return {
                    ...state,
                    actionsResponse: payload
                }
            }
            case actionTypes.ADMIN.ACCESS_CONTROL_LIST: {
                return {
                    ...state,
                    accessControlList: payload
                }
            }
            case actionTypes.ADMIN.SAVE_ACCESS_CONTROL_LIST: {
                return {
                    ...state,
                    saveResponse: payload
                }
            }
            case actionTypes.ADMIN.HISTORY_DATE_SUMMARY: {
                return {
                    ...state,
                    historyDateSummary: payload
                }
            }
        }
        return state;
    } catch (error) {
        return state;
    }
}
export default adminReducer;
